export enum CustomersRoles {
  COLLECTION_MANAGER = 'roles.customerCollectionManager',
  VIEWER = 'roles.customerViewer',
  EDITOR = 'roles.customerEditor',
  BULK_IMPORTER = 'roles.customerBulkImporter',
  BULK_EXPORTER = 'roles.customerBulkExporter',
  CLIENT_PORTAL_SHARE_SETTINGS_MANAGER = 'roles.customerClientPortalShareSettingsManager',
}
